module.exports = __webpack_public_path__ + "static/media/Info_JoSSA_2019_July.67ee7405.pdf";